import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";
import operationsName from "../../utils/operationsName";
import tablesName from "../../utils/tablesName";

const initialState = {
  logs: { count: 0, rows: [] },
  logsFilter: {
    page: 1,
    limit: 25,
    search: "",
    order: "desc",
    orderBy: "createdAt",
    startDate: null,
    endDate: null,
    filteredUsers: [],
    filteredTypes: [],
    filteredOperationsName: [],
    filteredTables: [],
    filteredDocumentsIds: [],
    filteredTenants: []
  },
  types: [
    // {
    //   value: 'get',
    //   label: 'get',
    // },
    {
      value: 'insert',
      label: 'insert',
    },
    {
      value: 'update',
      label: 'update',
    },
    {
      value: 'delete',
      label: 'delete',
    },
  ],
  operationsName,
  tables: tablesName,
  tenants: { count: 0, rows: [] },
  loadingTenants: false,
  users: { count: 0, rows: [] },
  loadingUsers: false,
  error: '',
  log: {},
  loading: false,
  loadingLog: false,
  employeeLogsSuperadmin: {
    count: 0,
    rows: []
  },
  employeeLoading: false
};

const requestLogsSuperadminStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const requestLogsSuperadminByIdStart = (state, action) => {
  return updateObject(state, { loadingLog: true });
};

const fetchLogsSuperadminSuccess = (state, action) => {
  return updateObject(state, {
    logs: action.logs,
    loading: false,
  });
};

const setLogsSuperadminFilter = (state, action) => {
  return updateObject(state, {
    logsFilter: action.logsFilter,
  });
};

const fetchLogsSuperadminByIdSuccess = (state, action) => {
  return updateObject(state, {
    log: action.log,
    loadingLog: false
  });
}


// OPTIONS FOR FILTER
const requestLogsSuperadminOptionsTenantsStart = (state, action) => {
  return updateObject(state, { loadingTenants: true });
};

const fetchLogsSuperadminOptionsTenantsSuccess = (state, action) => {
  return updateObject(state, {
    tenants: action.tenants,
    loadingTenants: false,
  });
};

const fetchLogsSuperadminOptionsTenantsFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loadingTenants: false,
  });
};

const requestLogsSuperadminOptionsUsersStart = (state, action) => {
  return updateObject(state, { loadingUsers: true });
};

const fetchLogsSuperadminOptionsUsersSuccess = (state, action) => {
  return updateObject(state, {
    users: action.users,
    loadingUsers: false,
  });
};

const fetchLogsSuperadminOptionsUsersFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loadingUsers: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_LOGS_SUPERADMIN_START:
      return requestLogsSuperadminStart(state, action);
    case actionTypes.REQUEST_LOG_BY_ID_START:
      return requestLogsSuperadminByIdStart(state, action);
    case actionTypes.FETCH_LOGS_SUPERADMIN_SUCCESS:
      return fetchLogsSuperadminSuccess(state, action);
    case actionTypes.SET_LOGS_SUPERADMIN_FILTER:
      return setLogsSuperadminFilter(state, action);
    case actionTypes.FETCH_LOGS_SUPERADMIN_BY_ID_SUCCESS:
      return fetchLogsSuperadminByIdSuccess(state, action);
    case actionTypes.REQUEST_LOGS_SUPERADMIN_OPTIONS_TENANTS_START:
      return requestLogsSuperadminOptionsTenantsStart(state, action);
    case actionTypes.FETCH_LOGS_SUPERADMIN_OPTIONS_TENANTS_SUCCESS:
      return fetchLogsSuperadminOptionsTenantsSuccess(state, action);
    case actionTypes.FETCH_LOGS_SUPERADMIN_OPTIONS_TENANTS_FAIL:
      return fetchLogsSuperadminOptionsTenantsFail(state, action);
    case actionTypes.REQUEST_LOGS_SUPERADMIN_OPTIONS_USERS_START:
      return requestLogsSuperadminOptionsUsersStart(state, action);
    case actionTypes.FETCH_LOGS_SUPERADMIN_OPTIONS_USERS_SUCCESS:
      return fetchLogsSuperadminOptionsUsersSuccess(state, action);
    case actionTypes.FETCH_LOGS_SUPERADMIN_OPTIONS_USERS_FAIL:
      return fetchLogsSuperadminOptionsUsersFail(state, action);
    default:
      return state;
  }
};

export default reducer;
